// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyC5q5bsoHj6W2S-iCtNSrVz3gUgXW2WlbM',
  authDomain: 'alectoaidemo.firebaseapp.com',
  databaseURL: 'https://alectoaidemo-default-rtdb.firebaseio.com',
  projectId: 'alectoaidemo',
  storageBucket: 'alectoaidemo.appspot.com',
  messagingSenderId: '550321402990',
  appId: '1:550321402990:web:57404ec053685a8716a27f',
  measurementId: 'G-YJSFGYJCLD'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export default app
